<script setup lang="ts">
import ReportsPage from '../features/reports/ReportsPage.vue';
</script>

<template>
  <ReportsPage />
</template>
